import { useEffect } from 'react';

// Locks .main (the app's real scroll container) while `isOpen` is true.
// Fluent's Panel portals outside .main's DOM subtree entirely and only
// manages document.body's scroll — it has no way to intercept .main's own
// overflow. Disabling .main's overflow is the only reliable way to stop it.
// scrollbar-gutter: stable on .main (see App.css) prevents any layout shift
// from the scrollbar appearing/disappearing.
export const useLockMainScroll = (isOpen: boolean): void => {
    useEffect(() => {
        const mainEl = document.querySelector<HTMLElement>('.main');
        if (!mainEl) return;

        if (isOpen) {
            const previousOverflow = mainEl.style.overflow;
            const previousScrollbarGutter = mainEl.style.scrollbarGutter;

            mainEl.style.scrollbarGutter = 'stable';
            mainEl.style.overflow = 'hidden';

            return () => {
                mainEl.style.overflow = previousOverflow;
                mainEl.style.scrollbarGutter = previousScrollbarGutter;
            };
        }
    }, [isOpen]);
};